const initialEnquiry = {
  enquiryLists: [],
  enquiryStatus: [],
  changedEnquiryStatus: [],
  loadingEnquiry: false,
  errorsEnquiry: {},
  enquiryCount: 0, 
};

const enquiryReducer = (state = initialEnquiry, action) => {
  switch (action.type) {
    case "GET_ENQUIRYLIST_PENDING":
    case "ADD_ENQUIRY_NOTE_PENDING":
    case "UPDATE_ENQUIRY_PENDING":
    case "UPDATE_ENQUIRY_STATUS_PENDING":
    case "DELETE_ENQUIRY_PENDING":
    case "GET_ENQUIRYLISTBYID_PENDING":
    case "SEND_QUOTATION_PENDING":
      return { ...state, loadingEnquiry: true };

    case "GET_ENQUIRYLIST_FULFILLED":
      return {
        ...state,
        loadingEnquiry: false,
        enquiryLists: action.payload,
        enquiryCount: action.enquiryCount,
        errorsEnquiry : {}
      };

    case "ADD_ENQUIRY_NOTE_FULFILLED":
      return {
        ...state,
        loadingEnquiry: false,
        changedEnquiryStatus: action.payload,
        errorsEnquiry: {},
      };

    case "UPDATE_ENQUIRY_FULFILLED":
      return {
        ...state,
        loadingEnquiry: false,
        changedEnquiryStatus: action.payload,
      };

    case "UPDATE_ENQUIRY_STATUS_FULFILLED":
      return {
        ...state,
        loadingEnquiry: false,
        changedEnquiryStatus: action.payload,
      };

    case "GET_ENQUIRYLISTBYID_FULFILLED":
      return {
        ...state,
        loadingEnquiry: false,
        enquiryLists: action.payload,
      };

    case "DELETE_ENQUIRY_FULFILLED":
      return {
        ...state,
        loadingEnquiry: false,
        changedEnquiryStatus: action.payload,
      };
    case "SEND_QUOTATION_FULFILLED":
      return {
        ...state,
        loadingEnquiry: false,
        changedEnquiryStatus: action.payload,
      };

      case "RESET_ENQUIRY_STATUS":
      case "RESET_DELETE_ENQUIRY_STATUS":
          return {
            ...state,
            loadingEnquiry: false,
            changedEnquiryStatus: [],
            errorsEnquiry: {},
          };

    case "GET_ENQUIRYLIST_REJECTED":
    case "ADD_ENQUIRY_NOTE_REJECTED":
    case "UPDATE_ENQUIRY_REJECTED":
    case "UPDATE_ENQUIRY_STATUS_REJECTED":
    case "DELETE_ENQUIRY_REJECTED":
    case "SEND_QUOTATION_REJECTED":
    case "GET_ENQUIRYLISTBYID_REJECTED":
      return {
        ...state,
        loadingEnquiry: false,
        errorsEnquiry: action.payload,
      };

    default:
      return state;
  }
};

export default enquiryReducer;
